export default __webpack_public_path__ + "static/media/trener1.cb1e2ecc.png";